import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const MatButtonCustomised = styled(Button)<{
    height?: string
    width?: string
    borderRadius?: string
}>(({ theme, height = undefined, width = undefined, borderRadius = undefined }) => ({
    '&.MuiButton-root': {
        minWidth: width || '56px',
        borderRadius,
        height,
        width,
        '&.Mui-disabled': {
            backgroundColor: `${theme.palette.action?.disabledBackground} !important`,
            color: `${theme.palette.action?.disabled} !important`
        },
        '&.MuiButton-containedWarning': {
            backgroundColor: theme.palette.warning?.main,
            color: theme.palette.primary?.main
        },
        '&.warning-action': {
            padding: '4px 8px',
            '.MuiTypography-root': {
                fontSize: '12px !important'
            }
        },
        '&.MuiButton-colorSecondary': {
            backgroundColor: theme.palette.grey?.[200],
            fontWeight: '400 !important',
            color: theme.palette.grey?.[700],
            '.MuiSvgIcon-root': {
                fill: theme.palette.grey?.[800]
            }
        },
        '&.MuiButton-colorPrimary': {
            '&.icon-only': {
                backgroundColor: 'transparent !important',
                marginRight: theme.spacing(0.5)
            },
            '&.secondary': {
                backgroundColor: theme.palette.background?.default,
                '.MuiSvgIcon-root': {
                    fill: theme.palette.grey?.[800]
                }
            },
            '&.button-in-active': {
                backgroundColor: theme.palette.grey?.[200],
                '.MuiSvgIcon-root': {
                    fill: theme.palette.grey?.[800]
                }
            }
        }
    }
}))

export { MatButtonCustomised }
